export default __webpack_public_path__ + "static/SCROLL_8-053f4eadf05e2e6ffb68805a0fe24e50.png";